import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=f4c48072&scoped=true"
import script from "./Dynamic.vue?vue&type=script&lang=js"
export * from "./Dynamic.vue?vue&type=script&lang=js"
import style0 from "./Dynamic.vue?vue&type=style&index=0&id=f4c48072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c48072",
  null
  
)

export default component.exports